import {Box, Checkbox, Grid, InputLabel, MenuItem, Select, Typography, FormControl, DialogTitle, Dialog, Paper} from "@material-ui/core";
import {DataGrid} from "@material-ui/data-grid";
import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {makeStyles} from "@material-ui/core/styles";
import _ from "lodash";
import DescriptionIcon from '@material-ui/icons/Description';

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    }, leftSection: {
        paddingTop: theme.spacing(3),

        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',

    }, dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function PayRollTableSection(props) {
    const {t} = useTranslation('payrollAdjustment');
    const dispatch = useDispatch();
    const classes = useStyles();
    const PAGE_SIZE = 20;

    const awardTypeList = [
        {
            id: 0,
            text: t('all'),
            value: -1
        },
        {
            id: 1,
            text: t('deduction'),
            value: 1
        },
        {
            id: 2,
            text: t('subsidy'),
            value: 2
        }
    ]
    const payrollDetailsColumns = [
        {field: 'id', headerName: t('id'), hide: true},
        {
            field: 'staff_id',
            headerName: t('driver_id'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.4
        },
        {
            field: 'staff_name',
            headerName: t('driver_name'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'trans_type',
            headerName: t('deduction_subsidy'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            renderCell: (params) => (
                <div
                    style={params.value == 0 ? {color: 'white'} : {color: 'Orange'}}
                >
                    <span style={{
                        color: "orange",
                        fontSize: 12
                    }}>{showAwardType(params.value)}</span>
                </div>
            ),
        },
        {
            field: 'amount',
            headerName: t('amount'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'charge_reason_name',
            headerName: t('reason'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.8,
        },
        {
            field: 'attachment_count',
            headerName: t('attachment'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            renderCell: (params) => (
                <div>
                    <span style={{fontSize: 12}}>{(params.value)}<DescriptionIcon
                        style={{verticalAlign: 'middle'}}/></span>
                </div>
            ),
        },
        {
            field: 'create_time',
            headerName: t('date'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
            renderCell: (params) => (
                <div>
                       <span style={{
                           color: "#fbfbfb",
                           fontSize: 12
                       }}>{showDate(params.value)}</span>
                </div>
            ),
        }
    ];

    const showAwardType = (value) => {
        if (!_.isNil(value)) {
            let type = _.filter(
                awardTypeList, (item) => {
                    return item.value === value
                })
            return type[0].text
        }
    }
    const showDate = (unixTimestamp) => {
        if (!_.isNil(unixTimestamp)) {
            const date = new Date(unixTimestamp * 1000);
            if (!_.isNil(props.timezone)) {
                return date.toLocaleString('en-US', {timeZone: props.timezone});
            } else {
                return date.toLocaleString();
            }
        }
        return "N/A";
    }

    return (
        <Box style={{margin: 30, paddingRight: 40}}>
            <DataGrid
                columns={payrollDetailsColumns}
                rows={props.allDriverDetails || []}
                pagination
                pageSize={PAGE_SIZE}
                alignItems="center"
                rowsPerPageOptions={[PAGE_SIZE]}
                checkboxSelection
                loading={props.isDataLoading}
                rowCount={props.allDriverDetails?.length || 0}
                onSelectionModelChange={(newSelection) => {
                    props.setSelectedItems(newSelection);
                }}
                onRowClick={(selectedRow) => props.handleRowClick(selectedRow)}
                disableSelectionOnClick
                style={{height: '75vh'}}
            />
        </Box>
    );

}

export default PayRollTableSection;